import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, DatePicker, Radio, Card, Input, Popconfirm, Checkbox, Empty } from 'antd';
import React, { useEffect, useState } from 'react';
import { DownloadOutlined, } from '@ant-design/icons';
import axios from 'axios';
const PreviewMp3Modal = (props) => {
    const handleDownload = () => {
        // console.log(props.file.file_id);
        axios
            .get('/cramSchool/api/media/classify_structure_type_file_download', {
                responseType: 'blob',
                params: {
                    file_id: props.file.file_id
                }
            })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `${props.file.file_client_name}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }
    return (
        <Modal
            open={props.open}
            // onOk={hideModal}
            onCancel={e => props.setOpen(false)}
            footer={false}
            width={600}
            style={{ padding: '20px' }}
        >
            <Row justify={'end'} style={{ paddingRight: '20px' }} gutter={[8, 16]}>
                <Col style={{ paddingRight: '40px', paddingTop: '10px' }}>
                    <Button type='primary' style={{ display: "inline-flex", alignItems: "center" }} icon={<DownloadOutlined />}
                        // onClick={e => window.open(`${axios.defaults.baseURL}/cramSchool/api/media/classify_structure_type_file_download?file_id=${props.file_id}`)}
                        onClick={handleDownload}
                    >檔案下載</Button>
                </Col>
                <Col span={24}>
                    <audio src={props.file_url} controls />
                </Col>
            </Row>

        </Modal>
    )
}
export default PreviewMp3Modal;